// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"eb75fbcb","124":"f047ae8b","128":"f151483d","307":"de4baa6a","497":"c5d7eb48","546":"28a396d8","711":"d3d0900d","899":"381659b2","952":"7e01602f"}[chunkId] + ".chunk.js";
};